module.exports = __webpack_public_path__ + "assets/6b7c34b88def4c1711c68607b9d4347f.mp3";